export default (length = 8) => {
  let randomNumber = window.crypto.getRandomValues(new Uint32Array(64));
  let randomStr = btoa(randomNumber).substr(Math.random() * 128, length);
  return randomStr;
};
